import React from "react"

const Output = ({ style }) => (
  <svg
    style={style}
    width="337"
    height="253"
    viewBox="0 0 337 253"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="79" y="169" width="136" height="5" rx="2" fill="#48494B" />
    <rect x="79" y="179" width="136" height="5" rx="2" fill="#48494B" />
    <rect x="62" y="189" width="148" height="5" rx="2" fill="#48494B" />
    <rect x="62" y="199" width="151" height="5" rx="2" fill="#48494B" />
    <rect x="62" y="209" width="83" height="5" rx="2" fill="#48494B" />
    <rect x="62" y="227" width="141" height="5" rx="2" fill="#48494B" />
    <rect x="62" y="237" width="148" height="5" rx="2" fill="#48494B" />
    <rect x="62" y="247" width="93" height="5" rx="2" fill="#48494B" />
    <path
      d="M68.72 184.336C67.776 184.336 66.76 184.208 65.672 183.952C64.6 183.696 63.76 183.416 63.152 183.112L63.512 179.848C65.624 180.872 67.48 181.384 69.08 181.384C69.928 181.384 70.592 181.224 71.072 180.904C71.552 180.568 71.792 180.08 71.792 179.44C71.792 178.96 71.656 178.568 71.384 178.264C71.128 177.944 70.752 177.68 70.256 177.472C69.76 177.248 68.968 176.944 67.88 176.56C66.856 176.208 66.008 175.84 65.336 175.456C64.664 175.056 64.128 174.552 63.728 173.944C63.344 173.32 63.152 172.56 63.152 171.664C63.152 170.224 63.68 169.064 64.736 168.184C65.792 167.304 67.304 166.864 69.272 166.864C70.2 166.864 71.12 166.968 72.032 167.176C72.96 167.384 73.808 167.64 74.576 167.944L74.264 171.088C73.272 170.656 72.36 170.336 71.528 170.128C70.712 169.904 69.896 169.792 69.08 169.792C68.168 169.792 67.472 169.944 66.992 170.248C66.512 170.552 66.272 170.992 66.272 171.568C66.272 172.016 66.4 172.384 66.656 172.672C66.912 172.96 67.256 173.2 67.688 173.392C68.136 173.584 68.792 173.816 69.656 174.088C71.592 174.696 73 175.4 73.88 176.2C74.776 176.984 75.224 178.064 75.224 179.44C75.224 180.752 74.768 181.896 73.856 182.872C72.944 183.848 71.232 184.336 68.72 184.336Z"
      fill="#48494B"
    />
    <rect width="268" height="155" rx="10" fill="#242729" />
    <rect
      opacity="0.5"
      x="19"
      y="18"
      width="120"
      height="120"
      rx="4"
      fill="url(#paint0a_linear)"
    />
    <rect x="159" y="47" width="87" height="13" rx="3" fill="#595A5E" />
    <rect x="159" y="69" width="44" height="8" rx="2" fill="#48494B" />
    <rect x="159" y="99" width="54" height="12" rx="1" fill="#1A1A1A" />
    <g filter="url(#filter0a_i)">
      <circle cx="284" cy="200" r="37" fill="url(#paint1a_linear)" />
    </g>
    <circle
      cx="284"
      cy="200"
      r="42.5"
      stroke="#9DD0FF"
      stroke-opacity="0.5"
      stroke-width="5"
    />
    <circle
      cx="284"
      cy="200"
      r="50.5"
      stroke="#9DD0FF"
      stroke-opacity="0.25"
      stroke-width="5"
    />
    <g filter="url(#filter1a_i)">
      <path
        d="M268.93 202.053C267.977 200.804 268.022 198.954 269.157 197.798C269.52 197.428 270.019 197.15 270.519 197.011C270.337 196.595 270.246 196.132 270.246 195.67C270.246 194.791 270.564 194.005 271.154 193.403C272.289 192.247 274.013 192.154 275.239 193.08C275.375 192.71 275.556 192.339 275.829 192.016C276.419 191.368 277.236 190.952 278.098 190.952C278.915 190.906 279.732 191.229 280.322 191.831C280.413 191.692 280.503 191.507 280.639 191.414C281.229 190.767 282.046 190.351 282.909 190.351C283.816 190.304 284.633 190.674 285.223 191.276L289.762 195.855C290.261 193.912 292.077 192.571 294.074 192.802C294.618 192.848 295.117 193.126 295.481 193.496C296.297 192.571 297.568 192.016 298.884 192.154C300.11 192.293 301.063 193.357 301.063 194.652L301.018 201.359C301.018 203.117 301.244 204.921 301.653 206.494V206.54C302.561 209.778 301.653 213.247 299.338 215.606C296.933 218.057 293.71 219.399 290.352 219.399C290.08 219.399 289.762 219.399 289.49 219.352C288.219 219.769 286.857 220 285.541 220C282.273 220 279.006 218.751 276.555 216.207L267.795 207.234C267.205 206.632 266.888 205.8 266.888 204.967C266.888 204.088 267.205 203.302 267.795 202.701C268.113 202.423 268.522 202.192 268.93 202.053ZM283.907 192.617C283.635 192.339 283.272 192.247 282.954 192.247C282.591 192.247 282.273 192.432 282.046 192.663C281.91 192.848 281.819 193.08 281.819 193.311L289.308 201.128L289.535 198.306L283.907 192.617ZM298.022 214.311C299.883 212.414 300.564 209.685 299.883 207.141C299.384 205.291 299.157 203.348 299.157 201.405L299.202 194.698C299.202 194.421 298.975 194.143 298.703 194.143C297.523 194.005 296.479 194.884 296.343 196.04L296.252 197.15L296.207 202.007C296.207 203.764 296.434 205.522 296.797 207.095C296.797 207.141 296.842 207.141 296.842 207.187C297.75 210.425 296.842 213.894 294.527 216.253C294.3 216.485 294.028 216.716 293.801 216.947C295.39 216.392 296.842 215.513 298.022 214.311ZM269.112 205.938L277.871 214.912C282.092 219.214 288.99 219.214 293.211 214.912C295.027 213.062 295.753 210.333 295.072 207.789V207.742C294.573 205.846 294.346 203.949 294.346 202.007V195.3C294.346 195.022 294.119 194.745 293.847 194.745C292.667 194.606 291.623 195.485 291.487 196.641L291.169 201.313C291.078 202.007 290.624 202.608 289.989 202.839C289.308 203.071 288.627 202.886 288.128 202.423L279.142 193.265C278.869 192.987 278.643 192.848 278.189 192.895C277.826 192.895 277.508 193.08 277.281 193.311C276.872 193.773 276.918 194.698 277.417 195.207L284.089 202.053C284.452 202.423 284.452 203.024 284.089 203.394C283.907 203.579 283.68 203.672 283.408 203.672C283.181 203.672 282.909 203.579 282.727 203.394L276.01 196.549L274.24 194.745C273.741 194.236 272.924 194.236 272.425 194.745C272.198 194.976 272.062 195.3 272.062 195.67C272.062 196.04 272.198 196.364 272.425 196.595L280.957 205.245C281.32 205.615 281.32 206.216 280.957 206.586C280.776 206.771 280.549 206.864 280.276 206.864C280.004 206.864 279.777 206.771 279.596 206.586L274.83 201.729L272.289 199.139C271.789 198.63 270.972 198.63 270.473 199.139C269.974 199.648 269.974 200.48 270.473 200.989L272.198 202.747L273.469 203.996L277.826 208.436C278.189 208.806 278.189 209.408 277.826 209.778C277.644 209.963 277.417 210.055 277.145 210.055C276.872 210.055 276.646 209.963 276.464 209.778L270.882 204.088C270.382 203.579 269.565 203.579 269.066 204.088C268.839 204.32 268.703 204.643 268.703 205.013C268.703 205.383 268.839 205.707 269.112 205.938ZM275.692 186.28L273.378 181.238C273.151 180.776 272.606 180.544 272.152 180.776C271.699 181.007 271.472 181.562 271.699 182.025L273.968 187.113C274.149 187.483 274.467 187.668 274.83 187.668C274.966 187.668 275.102 187.621 275.239 187.575C275.692 187.344 275.874 186.743 275.692 186.28ZM281.819 181.192C281.956 180.683 281.638 180.174 281.139 180.036C280.639 179.897 280.14 180.174 280.004 180.683L278.597 186.049C278.461 186.558 278.779 187.066 279.278 187.205C279.369 187.205 279.459 187.251 279.505 187.251C279.913 187.251 280.276 186.974 280.413 186.558L281.819 181.192ZM265.526 187.899L270.473 190.258C270.609 190.304 270.745 190.351 270.882 190.351C271.245 190.351 271.562 190.165 271.744 189.795C271.971 189.333 271.744 188.732 271.29 188.547L266.343 186.188C265.889 185.956 265.299 186.188 265.118 186.65C264.845 187.113 265.072 187.668 265.526 187.899Z"
        fill="white"
      />
    </g>
    <rect
      x="256"
      y="110"
      width="55"
      height="30"
      rx="4"
      fill="#48494B"
      fill-opacity="0.5"
    />
    <path
      d="M269.68 127.4H267.12L267.44 125.52H270L270.48 122.84H272.52L272.04 125.52H274.6L274.28 127.4H271.72L271.24 130.08H269.2L269.68 127.4ZM278.266 121.62C277.626 121.993 276.993 122.233 276.366 122.34L276.526 120.18C276.993 120.087 277.539 119.82 278.166 119.38C278.793 118.927 279.239 118.467 279.506 118H281.466L278.986 132H276.426L278.266 121.62ZM287.772 132.28C286.318 132.28 285.178 131.793 284.352 130.82C283.525 129.833 283.112 128.493 283.112 126.8C283.112 125.24 283.412 123.767 284.012 122.38C284.625 120.98 285.478 119.853 286.572 119C287.678 118.147 288.932 117.72 290.332 117.72C291.798 117.72 292.945 118.207 293.772 119.18C294.598 120.14 295.012 121.44 295.012 123.08C295.012 124.64 294.705 126.127 294.092 127.54C293.478 128.953 292.618 130.1 291.512 130.98C290.418 131.847 289.172 132.28 287.772 132.28ZM288.172 129.98C289.065 129.98 289.832 129.64 290.472 128.96C291.112 128.28 291.598 127.42 291.932 126.38C292.265 125.34 292.432 124.3 292.432 123.26C292.432 122.18 292.205 121.367 291.752 120.82C291.312 120.26 290.705 119.98 289.932 119.98C289.025 119.98 288.252 120.313 287.612 120.98C286.972 121.633 286.485 122.48 286.152 123.52C285.832 124.547 285.672 125.6 285.672 126.68C285.672 127.787 285.892 128.613 286.332 129.16C286.785 129.707 287.398 129.98 288.172 129.98Z"
      fill="#A7A7A7"
    />
    <defs>
      <filter
        id="filter0a_i"
        x="247"
        y="163"
        width="74"
        height="74"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter1a_i"
        x="265"
        y="180"
        width="37"
        height="40"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <linearGradient
        id="paint0a_linear"
        x1="79"
        y1="18"
        x2="79"
        y2="138"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#008BFF" stop-opacity="0.27" />
        <stop offset="1" stop-color="#9DD0FF" stop-opacity="0.26" />
      </linearGradient>
      <linearGradient
        id="paint1a_linear"
        x1="284"
        y1="163"
        x2="284"
        y2="237"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
    </defs>
  </svg>
)

export default Output
